import VueRouter from "vue-router";
import AdminDashboard from "./views/admin/Dashboard";
import Email from "./views/admin/email";
import Error from "./components/Error";
import UserProfile from "./views/user/Profile";
import AdminProfile from "./views/admin/Profile";
import walletOverview from "./views/user/Dashboard";
import cardRequests from "./views/user/CardRequests";
import loanRequests from "./views/user/LoanRequests";
import transactions from "./views/user/Transactions";
import Register from "./views/auth/Register";
import Users from "./views/admin/Users";
import AdminCardRequests from "./views/admin/CardRequests";
import AdminLoanRequests from "./views/admin/Loans";
import AdminUserEdit from "./views/admin/user/Edit";
import Administration from "./views/admin/settings/Administration";
import Gateways from "./views/admin/settings/Gateways";
import Rates from "./views/admin/settings/Rates";
import Notifications from "./views/admin/settings/Notifications";
import Settings from "./views/admin/settings/Settings";

export let routes = [
    // admin routes
    {
        path: "/management/dashboard",
        name: "admin-dashboard",
        component: AdminDashboard
    },
    {
        path: "/management/users",
        name: "users",
        component: Users
    },
    {
        path: "/management/user/edit/:id",
        name: "adminUserEdit",
        component: AdminUserEdit
    },
    {
        path: "/management/administration",
        name: "admins",
        component: Administration
    },
    {
        path: "/management/gateways",
        name: "gateways",
        component: Gateways
    },
    {
        path: "/management/loan-requests",
        name: "loanRequests",
        component: AdminLoanRequests
    },
    {
        path: "/management/card-requests",
        name: "cardRequests",
        component: AdminCardRequests
    },
    {
        path: "/management/Rates",
        name: "Rates",
        component: Rates
    },
    {
        path: "/management/settings",
        name: "settings",
        component: Settings
    },
    {
        path: "/management/notification-settings",
        name: "notif-settings",
        component: Notifications
    },
    {
        path: "/management/email",
        name: "email",
        component: Email
    },
    {
        path: "/management/profile",
        name: "AdminProfile",
        component: AdminProfile
    },

    //Authentication
    {
        path: "/register",
        name: "register",
        component: Register
    },


    // user routes
    {
        path: "/profile",
        name: "userProfile",
        component: UserProfile
    },
    {
        path: "/card-requests",
        name: "cardRequests",
        component: cardRequests
    },
    {
        path: "/loan-requests",
        name: "loanRequests",
        component: loanRequests
    },
    {
        path: "/transactions",
        name: "transactions",
        component: transactions
    },




    //general route
    {
        path: "*",
        name: "/dashboard",
        component: walletOverview
    }
];
